import Project1 from "../../assets/project1.png";
import Project2 from "../../assets/project2.png";
import Project3 from "../../assets/project3.png";
import Project4 from "../../assets/project4.png";
import Project5 from "../../assets/project5.png";
import Project6 from "../../assets/project6.png";
import Project7 from "../../assets/project7.png";
import Project8 from "../../assets/project8.png";


export const projectsData = [
    {
        id: 1,
        visit:`https://masaionwards.vercel.app/login`,
        github:`https://github.com/sheeluofficial/Onwards_Hackathon_Project`,
        image: Project1,
        title: "Onwards - Masai",
        category: "Top Projects",
        description:`
        The project was built in a hackathon, This provides the complete admission
         flow by assessing you and suggesting course based on performance an then onboarding
        `,
        techStack: `Node.js | Express | MongoDB | Mongoose | Nodemailer | Twillio | React | Chakra-UI
        `
    },
    {
        id: 2,
        visit:`https://sportsmall.vercel.app/`,
        github:`https://github.com/sheeluofficial/SportsMall`,
        image: Project2,
        title: "SportsMall",
        category: "Top Projects",
        description:`
        The project was built in a hackathon, This provides the complete admission
         flow by assessing you and suggesting course based on performance an then onboarding
        `,
        techStack: `Node.js | Express | MongoDB | Mongoose | Nodemailer | Cloudinary  | Stripe | React | Redux`
        
    },
    {
        id: 3,
        visit:`https://talk-gpt.onrender.com/`,
        github:`https://github.com/sheeluofficial/talk-gpt`,
        image: Project3,
        title: "Talk-gpt",
        category: "Top Projects",
        description:`
       An Application built with OpenAI API that works like ChatGPT
        `,
        techStack: `Node.js | Express | MongoDB | Mongoose | OpenAI API | React
        `
    },
    {
        id: 4,
        visit:`https://westside-ecommerce-clone.vercel.app/`,
        github:`https://github.com/sheeluofficial/westside-clone-1/tree/main`,
        image: Project4,
        title: "Westside Clone",
        category: "Top Projects",
        description:`
       The website is a clone of westside. An E-commerce of fashion & beauty
        `,
        techStack: `HTML | CSS | JavaScript | MongoDB | Express | Node.js
        `
    },
    {
        id: 8,
        visit:`https://confident-varahamihira-56d964.netlify.app/`,
        github:`https://github.com/sheeluofficial/sportsjam.in-clone`,
        image: Project8,
        title: "Sportsjam clone",
        category: "Top Projects",
        description:`
        This is the clone of an E - Commerce site sportsjam that sells sports products.
        `,
        techStack: ` HTML | CSS | JavaScript 
        `
    },
    {
        id: 5,
        visit:`https://frosty-franklin-e35939.netlify.app/`,
        github:`https://github.com/sheeluofficial/weatherApp-API`,
        image: Project5,
        title: "Weather APP",
        category: "Mini Projects",
        description:`
       An Application to check weather of your city. Used open weater API
        `,
        techStack: ` HTML | CSS | JavaScript | OpenWeather API
        `
    },
    {
        id: 6,
        visit:`https://loving-euler-653170.netlify.app/`,
        github:`https://github.com/sheeluofficial/Jiomart.com-clone`,
        image: Project6,
        title: "Jiomart clone",
        category: "Mini Projects",
        description:`
       This is the clone of an E-Commerce website JioMart
        `,
        techStack: ` HTML | CSS | JavaScript 
        `
    },
    {
        id: 7,
        visit:`https://peaceful-allen-90d197.netlify.app/`,
        github:`https://github.com/sheeluofficial/youtube-clone`,
        image: Project7,
        title: "Mini - Youtube Clone",
        category: "Mini Projects",
        description:`
      Mini - Youtube Clone
        `,
        techStack: ` HTML | CSS | JavaScript 
        `
    },
   
];

export const projectsNav = [
    {
        name: "All",
    },
    {
        name: "Top Projects",
    },
    {
        name: "Mini Projects",
    }
];

